const React = require('react');
const isDefined = require('mn-utils/isDefined');
const Tooltip = require('@material-ui/core/Tooltip').default;
const formatNum = require('../../../../utils/formatNum');
const withState = require('../../../../utils/withState');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const Ripple = require('../../../dumb/Ripple');


function FieldA(props) {
  const {
    value,
  } = props;
  return (
    <div className="pv10">
      <div className="layoutRow fhaB fvaC">
        <div>
          <div
            className="f12 o70"
          >{props.label}</div>
          <div className="f16">
            <Tooltip
              title={value}
              placement="top"
            >
              <div className="rlv z1">
                {formatNum(value, 2)}
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      <div
        className="mt5 f12"
      >{props.description}</div>
    </div>
  );
}


module.exports = withState((setState) => {
  return (state) => {
    const {
      withdrawable,
    } = state;
    const cash = state.cash || {};
    const amountTotal = withdrawable
      ? 0
      : cash.amount || cash.total || 0;
    const amountPending = cash.pending || 0;
    let amountAvailable = withdrawable
      ? 0
      : cash.available;
    isDefined(amountAvailable) || (amountAvailable = amountTotal);


    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <div className="layoutRow fhaS fvaC">
          <div className="rlv">
            <div className="abs sv-10 sh-15 dn r5 bg2E3034<1:h"/>
            <Tooltip
              title={amountTotal}
              placement="top"
            >
              <div className="cF rlv z1 f48 lh ff$2 fw5 lts0.12em ov ws">
                {formatNum(amountTotal, 2)}
                <span
                  className="lts-0.02em"
                >{cash.asset_code}</span>
              </div>
            </Tooltip>
            <div className="rlv">
              <div className="abs sl-15 st pt20 p10 bg2E3034 ov r5 w300
                z-1 o0 dn (z10|o100)<2:h">
                <FieldA
                  label="Total"
                  value={amountTotal}
                  description={(
                    <div>
                      Total balance, including all transactions since
                      the last withdrawal
                    </div>
                  )}
                />
                <FieldA
                  label="Pending"
                  value={amountPending}
                  description={(
                    <div>
                      The amount of transactions made within last 30 days that
                      are temporarily unavailable for withdrawal.
                    </div>
                  )}
                />
                <FieldA
                  label="Available"
                  value={amountAvailable}
                  description={(
                    <div>
                      The amount of transactions for a period above 30
                      days and which are available for withdrawal to a bank account
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
          <div className="rlv">
            <Ripple
              className="dn h54 bg0.35 bg0.44:not[.disabled]:h ttU r6 wmin140
                layoutRow olN tdN fhaC fvaC cF lh fw5 f16 ovH ml30 o50.disabled
                usN"
              disabled
            >Withdraw</Ripple>
          </div>
        </div>
      </WrapperWithLoading>
    );
  };
});
